
/* styles */
require("!!../../../node_modules/.store/extract-text-webpack-plugin@2.1.2/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-32b3884f\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/selector?type=styles&index=0!./ImportButton.vue")

var Component = require("!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/selector?type=script&index=0!./ImportButton.vue"),
  /* template */
  require("!!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-32b3884f\"}!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/selector?type=template&index=0!./ImportButton.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/myButton/ImportButton.vue
// module id = 1774
// module chunks = 1